// NO EDITAR A MANO
// const id = "footer.text_footer";
const valor = `Download the favorite app for weather enthusiasts.`;

export default valor;
